// routes/VerificationRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const VerificationRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const emailVerified = localStorage.getItem('email_verify');

  // If token is missing or empty
  if (!token) {
    return <Navigate to="/signin" replace />;
  }
  // If emailVerified is null, undefined, or not 'true'
  if (emailVerified === 'false' ||  emailVerified === false) {
      return children ? children : <Outlet />;
  }else{
    return <Navigate to="/signin" replace />;
  }
};

export default VerificationRoute;
